/* @ngInject */
class NoticesService {
	constructor(Notices, localStorageService, $q) {
		this.Notices             = Notices;
		this.localStorageService = localStorageService;
		this.$q                  = $q;
	}

	hasAnyNotViewed() {
		let deferred = this.$q.defer();

		this.getNotViewed()
		    .then((notices) => {
			    deferred.resolve(notices.length > 0);
		    }, () => {
			    deferred.resolve(false);
		    });

		return deferred.promise;
	}

	getNotViewed() {
		let deferred = this.$q.defer();

		this.Notices
		    .getVisible()
		    .getList()
		    .then((notices) => {
			    deferred.resolve(
				    notices.filter((notice) => {
					    const id   = notice.id;
					    const hash = notice.hash;

					    const locallyStoredHash = this.localStorageService.get(`notice-${id}`);

					    return locallyStoredHash !== hash;
				    }),
			    );
		    }, () => {
			    deferred.resolve([]);
		    });

		return deferred.promise;
	}

	markAsViewed(id, hash) {
		this.localStorageService.set(`notice-${id}`, hash);
	}
}

export default NoticesService;


// WEBPACK FOOTER //
// ./src/js/services/notices/index.js